import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Carrinho(props) {
  const [usuarioId] = useState(Number(props.match.params.id));
  const { notification } = useContext(AppContext);
  const [carrinho, setCarrinho] = useState([]);
  const [dadosCarrinho, setDadosCarrinho] = useState({});
  const [carregando, setCarregando] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(false);
  const [item, setItem] = useState({});
  const history = props.history;

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    setCarregando(true);
    api
      .get("carrinhos/carregar", { usuarioId })
      .then((res) => {
        const dadosCarrinho = res[0];
        res.forEach((item) => {
          item.valorUnitario = `R$ ${(item.valorItemCentavos / 100).toFixed(
            2
          )}`;
          item.valorTotal = `R$ ${(
            (item.valorItemCentavos * item.quantidade) /
            100
          ).toFixed(2)}`;
        });

        let carrinhoAtualizado = res.filter((item) => item.quantidade > 0);

        setCarrinho(carrinhoAtualizado);
        setCarregando(false);
        setDadosCarrinho(dadosCarrinho);
      })
      .catch((e) => notification("warning", "Erro ao carregar carrinho"));
  };

  const fDados = {
    title: "Carrinho Aberto",
    form: {
      cep: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Profissional</h4>
            <p>{dadosCarrinho.usuarioNome}</p>
          </div>
        ),
      },
      endereco: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Escola</h4>
            <p>{dadosCarrinho.escolaNome}</p>
          </div>
        ),
      },
    },

    submit: {
      label: "Fechar pedido",
      action: () => history.push(`/app/carrinho/fechamento/${usuarioId}`),
    },

    close: true,
    history,
  };

  const abrirCarrinho = (param) => {
    setItemSelecionado(true);
    setItem(param);
  };

  const removerItem = () => {
    api
      .post("carrinhos/removerItem", {
        usuarioId: usuarioId,
        produtoId: item.produtoId,
        quantidade: Number(item.quantidade),
      })
      .then((res) => {
        notification("success", "Item removido!");
        setItemSelecionado(false);
        setItem({});
        carregar();
      })
      .catch((err) => {
        return notification("error", "Erro ao remover item");
      });
  };

  const salvarItem = (params) => {
    let valor = Number(params.valor) * 100;
    let quantidade = Number(params.quantidade);

    api
      .post("carrinhos/editarItem", {
        usuarioId,
        produtoId: item.produtoId,
        valor: valor,
        quantidade: quantidade,
      })
      .then((res) => {
        notification("success", "Item editado!");
        setItemSelecionado(false);
        setItem({});
        carregar();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Quantidade inválida");
          case 3:
            return notification("error", "Valor inválido");
          case 4:
            return notification("error", "Produto inválido");
          case 5:
            return notification(
              "error",
              "Produto com venda exclusiva para outra(s) escola(s)"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fItem = {
    title: "Editar item",
    form: {
      endereco: {
        label: "Componente",
        type: "component",
        // space: 6,
        value: (
          <div>
            <h4>Produto</h4>
            <p>{item.produtoNome}</p>
          </div>
        ),
      },
      quantidade: {
        label: "Quantidade",
        type: "number",
        value: item.quantidade,
        space: 6,
      },
      valor: {
        label: "Valor unitário (R$)",
        type: "number",
        value: (item.valorItemCentavos / 100).toFixed(2),
        space: 6,
      },
    },

    submit: {
      label: "salvar",
      action: salvarItem,
    },

    close: {
      label: "Fechar",
      action: () => {
        setItemSelecionado(false);
        setItem({});
      },
    },

    customActions: [
      {
        label: "remover item",
        action: () => removerItem(),
      },
    ],
  };

  const tRegistros = {
    title: "Itens",
    onLineClick: abrirCarrinho,
    newItemAction: () => history.push(`/app/carrinho/catalogo/${usuarioId}`),
    columns: [
      {
        name: "produtoNome",
        label: "Produto",
      },
      {
        name: "quantidade",
        label: "Quantidade",
      },
      {
        name: "valorUnitario",
        label: "Valor unitário",
      },
      {
        name: "valorTotal",
        label: "Valor total",
      },
    ],
    array: carrinho,
  };

  return (
    <div>
      {!itemSelecionado ? (
        <>
          <Form formData={fDados} />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      ) : (
        <Form formData={fItem} />
      )}
    </div>
  );
}
